'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  border: 1px solid transparent;\n  border-top-color: ', ';\n  border-left-color: ', ';\n  top: ', 'px;\n  left: ', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  transform: rotate(\n    ', 'deg\n  );\n  background-color: ', ';\n'], ['\n  border: 1px solid transparent;\n  border-top-color: ', ';\n  border-left-color: ', ';\n  top: ', 'px;\n  left: ', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  transform: rotate(\n    ', 'deg\n  );\n  background-color: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Arrow = exports.Arrow = _styledComponents2.default.span(_templateObject, function (props) {
  return props.borderColor || props.backgroundColor;
}, function (props) {
  return props.borderColor || props.backgroundColor;
}, function (props) {
  return props.arrowPosition.y;
}, function (props) {
  return props.arrowPosition.x;
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return calcArrowRotation(props.verticalAlignment, props.horizontalAlignment);
}, function (props) {
  return props.backgroundColor;
});
function calcArrowRotation(verticalAlignment, horizontalAlignment) {
  var rotation = 45;
  if (verticalAlignment === 'top') {
    return rotation + 180;
  }
  return rotation;
}
//# sourceMappingURL=styles.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tooltip/styles.js